import { ExternalServices_instancen7y3lfkh3gae as ExternalServices_instance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ExternalLink3fl954ixvn5zt as ExternalLink } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ExternalLink.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import {
  ImageRemote256pcav1ipbca as ImageRemote,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  substringBefore3n7kj60w69hju as substringBefore,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Companion_instancegwok6qx7et5m as Companion_instance,
  FormSelector1zdq40oqbcvms as FormSelector,
  FormRendererv0cfjgipxuxv as FormRenderer,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  get_kind27kjvyfnc9an8 as get_kind,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  size1hf9cj08wgoyn as size,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = ExternalServices_instance.ucu(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_0 = ensureNotNull($this.te0_1.jdt_1)(tmp0_safe_receiver, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = $this.se0_1.gah(tmp_0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
function ExternalLink$_get_enabled_$ref_1hoozk(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function ExternalLink$_set_enabled_$ref_ssphcc(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function ExternalLink$_get_to_$ref_jqs3qa(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.href;
    return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  };
}
function ExternalLink$_set_to_$ref_l7iod2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    p0.tb5_1.zb3_1.ib7_1.href = _this__u8e3s4;
    return Unit_instance;
  };
}
function ImageView$_get_source_$ref_ain7z1(p0) {
  return () => p0.i2i();
}
function ImageView$_set_source_$ref_4jld67(p0) {
  return (_this__u8e3s4) => {
    p0.oda(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_exists_$ref_l7zxkg(p0) {
  return () => p0.cba();
}
function Button$_set_exists_$ref_yqvj9g(p0) {
  return (_this__u8e3s4) => {
    p0.bba(_this__u8e3s4);
    return Unit_instance;
  };
}
var ServerFileRenderer$form$lambda$slambdaClass;
function ServerFileRenderer$form$lambda$slambda() {
  if (ServerFileRenderer$form$lambda$slambdaClass === VOID) {
    class $ {
      constructor($mutable, $module) {
        this.se0_1 = $mutable;
        this.te0_1 = $module;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ServerFileRenderer$form$lambda$slambdaClass = $;
  }
  return ServerFileRenderer$form$lambda$slambdaClass;
}
function ServerFileRenderer$form$lambda$slambda_0($mutable, $module) {
  var i = new (ServerFileRenderer$form$lambda$slambda())($mutable, $module);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function ServerFileRenderer$view$lambda($this$ViewRenderer, field, readable) {
  // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (ExternalLink())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.newTab' call
  var tmp0 = view.tb5_1.zb3_1;
  // Inline function 'com.lightningkite.kiteui.views.target' call
  var value = true ? '_blank' : '_self';
  tmp0.ib7_1.target = value;
  var tmp = KMutableProperty0();
  var tmp_0 = ExternalLink$_get_to_$ref_jqs3qa_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('to', 0, tmp, tmp_0, ExternalLink$_set_to_$ref_l7iod2_0(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp = $this$reactiveScope.baj(readable);
    var tmp0_safe_receiver = tmp == null ? null : tmp.n2n_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp$ret$2 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var tmp_1 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(3), get_rem(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.image' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (ImageView())(view_0);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = ImageView$_get_source_$ref_ain7z1_0(this_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('source', 0, tmp_2, tmp_3, ImageView$_set_source_$ref_4jld67_0(this_1));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp = $this$reactiveScope.baj(readable);
    var tmp0_safe_receiver = tmp == null ? null : tmp.n2n_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = tmp_0;
    var tmp_2;
    if (tmp1_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = new (ImageRemote())(tmp1_safe_receiver);
    }
    var tmp$ret$6 = tmp_2;
    this_2.set(tmp$ret$6);
    return Unit_instance;
  });
  this_1.zba();
  view_0.jbb(tmp_1, this_1);
  var tmp_4 = view_0.ibb(get_centered(view_0), get_expanding(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xco(true);
  view_1.yco(false);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_0(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp = $this$reactiveScope.baj(readable);
    var tmp0_safe_receiver = tmp == null ? null : tmp.n2n_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = tmp_0;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : substringAfterLast(tmp1_safe_receiver, _Char___init__impl__6a9atx(47));
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : substringBefore(tmp2_safe_receiver, _Char___init__impl__6a9atx(63));
    var tmp$ret$12 = tmp3_elvis_lhs == null ? 'None' : tmp3_elvis_lhs;
    this_3.set(tmp$ret$12);
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_4, view_1);
  view.fbb(p_0, view_0);
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function ExternalLink$_get_to_$ref_jqs3qa_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.href;
    return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  };
}
function ExternalLink$_set_to_$ref_l7iod2_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    p0.tb5_1.zb3_1.ib7_1.href = _this__u8e3s4;
    return Unit_instance;
  };
}
function ImageView$_get_source_$ref_ain7z1_0(p0) {
  return () => p0.i2i();
}
function ImageView$_set_source_$ref_4jld67_0(p0) {
  return (_this__u8e3s4) => {
    p0.oda(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var ServerFileRendererClass;
function ServerFileRenderer() {
  if (ServerFileRendererClass === VOID) {
    class $ {
      constructor() {
        this.ue0_1 = 'File';
        this.ve0_1 = 'com.lightningkite.lightningserver.files.ServerFile';
      }
      k20() {
        return this.ue0_1;
      }
      f94() {
        return this.ve0_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, ($this$FormRenderer, field, mutable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.ebb(p, view);
          view.xbm(false);
          var tmp = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (ExternalLink())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.newTab' call
          var tmp0 = view_0.tb5_1.zb3_1;
          // Inline function 'com.lightningkite.kiteui.views.target' call
          var value = true ? '_blank' : '_self';
          tmp0.ib7_1.target = value;
          var tmp_0 = KMutableProperty0();
          var tmp_1 = ExternalLink$_get_enabled_$ref_1hoozk(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, ExternalLink$_set_enabled_$ref_ssphcc(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            var tmp$ret$2 = !($this$reactiveScope.baj(mutable) == null);
            this_0.set(tmp$ret$2);
            return Unit_instance;
          });
          var tmp_2 = KMutableProperty0();
          var tmp_3 = ExternalLink$_get_to_$ref_jqs3qa(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('to', 0, tmp_2, tmp_3, ExternalLink$_set_to_$ref_l7iod2(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            var tmp = $this$reactiveScope.baj(mutable);
            var tmp0_safe_receiver = tmp == null ? null : tmp.n2n_1;
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
            }
            var tmp$ret$4 = tmp_0;
            this_1.set(tmp$ret$4);
            return Unit_instance;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.ebb(p_1, view_1);
          view_1.xbm(false);
          var tmp_4 = sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, get_rem(3), get_rem(3));
          // Inline function 'com.lightningkite.kiteui.views.direct.image' call
          // Inline function 'kotlin.apply' call
          var this_2 = new (ImageView())(view_1);
          var tmp_5 = KMutableProperty0();
          var tmp_6 = ImageView$_get_source_$ref_ain7z1(this_2);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_3 = getPropertyCallableRef('source', 0, tmp_5, tmp_6, ImageView$_set_source_$ref_4jld67(this_2));
          reactiveScope(view_1, ($this$reactiveScope) => {
            var tmp = $this$reactiveScope.baj(mutable);
            var tmp0_safe_receiver = tmp == null ? null : tmp.n2n_1;
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
            }
            var tmp1_safe_receiver = tmp_0;
            var tmp_2;
            if (tmp1_safe_receiver == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_2 = new (ImageRemote())(tmp1_safe_receiver);
            }
            var tmp$ret$8 = tmp_2;
            this_3.set(tmp$ret$8);
            return Unit_instance;
          });
          this_2.zba();
          view_1.jbb(tmp_4, this_2);
          var tmp_7 = view_1.ibb(get_centered(view_1), get_expanding(view_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (TextView())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.ebb(p_2, view_2);
          view_2.xco(true);
          view_2.yco(false);
          var tmp_8 = KMutableProperty0();
          var tmp_9 = TextView$_get_content_$ref_4pzcwl(view_2);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_4 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(view_2));
          reactiveScope(view_2, ($this$reactiveScope) => {
            var tmp = $this$reactiveScope.baj(mutable);
            var tmp0_safe_receiver = tmp == null ? null : tmp.n2n_1;
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
            }
            var tmp1_safe_receiver = tmp_0;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : substringAfterLast(tmp1_safe_receiver, _Char___init__impl__6a9atx(47));
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : substringBefore(tmp2_safe_receiver, _Char___init__impl__6a9atx(63));
            var tmp_2;
            if (tmp3_safe_receiver == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.takeUnless' call
              var tmp_3;
              if (!isBlank(tmp3_safe_receiver)) {
                tmp_3 = tmp3_safe_receiver;
              } else {
                tmp_3 = null;
              }
              tmp_2 = tmp_3;
            }
            var tmp4_elvis_lhs = tmp_2;
            var tmp$ret$16 = tmp4_elvis_lhs == null ? 'None' : tmp4_elvis_lhs;
            this_4.set(tmp$ret$16);
            return Unit_instance;
          });
          view_1.fbb(p_2, view_2);
          view_1.jbb(tmp_7, view_2);
          view_0.fbb(p_1, view_1);
          view.fbb(p_0, view_0);
          view.jbb(tmp, view_0);
          var tmp_10 = get_centered(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Button())(view.pc());
          var tmp0_elvis_lhs_3 = view.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.ebb(p_3, view_3);
          var tmp_11 = KMutableProperty0();
          var tmp_12 = Button$_get_exists_$ref_l7zxkg(view_3);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_5 = getPropertyCallableRef('exists', 0, tmp_11, tmp_12, Button$_set_exists_$ref_yqvj9g(view_3));
          reactiveScope(view_3, ($this$reactiveScope) => {
            var tmp$ret$28 = !(module_0.jdt_1 == null);
            this_5.set(tmp$ret$28);
            return Unit_instance;
          });
          icon(view_3, Companion_getInstance().pcf_1, 'Upload');
          onClick(view_3, VOID, VOID, ServerFileRenderer$form$lambda$slambda_0(mutable, module_0));
          view.fbb(p_3, view_3);
          view.jbb(tmp_10, view_3);
          $this$FormRenderer.fbb(p, view);
          return view;
        });
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, ServerFileRenderer$view$lambda);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).idu = size;
    protoOf($).cdu = get_basePriority;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForObject($, 'ServerFileRenderer', VOID, VOID, [Generator(), Generator_0()]);
    ServerFileRendererClass = $;
  }
  return ServerFileRendererClass;
}
var ServerFileRenderer_instance;
function ServerFileRenderer_getInstance() {
  return ServerFileRenderer_instance;
}
//region block: init
ServerFileRenderer_instance = new (ServerFileRenderer())();
//endregion
//region block: exports
export {
  ServerFileRenderer_instance as ServerFileRenderer_instancerzww5z0kqvmd,
};
//endregion

//# sourceMappingURL=ServerFileRenderer.mjs.map
